/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DuplicateVariantRequestPost } from '../../models/duplicate-variant-request-post';
import { DuplicateVariantResponse } from '../../models/duplicate-variant-response';

export interface VariantsControllerDuplicateVariant$Params {

/**
 * The id of the variant to duplicate.
 */
  id: string;
      body: DuplicateVariantRequestPost
}

export function variantsControllerDuplicateVariant(http: HttpClient, rootUrl: string, params: VariantsControllerDuplicateVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<DuplicateVariantResponse>> {
  const rb = new RequestBuilder(rootUrl, variantsControllerDuplicateVariant.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DuplicateVariantResponse>;
    })
  );
}

variantsControllerDuplicateVariant.PATH = '/planning-projects/v1-develop/projects/variants/{id}/duplicate';
